import { devicesRef, pharmaciesRef, deviceRef, databaseRef } from "../../../Config/FirebaseDatabase";
import moment from 'moment';

export const FETCH_DEVICES_PENDING = 'FETCH_DEVICES_PENDING';
export const FETCH_DEVICES_FULFILLED = 'FETCH_DEVICES_FULFILLED';
export const FETCH_DEVICES_REJECTED = 'FETCH_DEVICES_REJECTED';
export const FETCH_DEVICE_PENDING = 'FETCH_DEVICE_PENDING';
export const FETCH_DEVICE_FULFILLED = 'FETCH_DEVICE_FULFILLED';
export const FETCH_DEVICE_REJECTED = 'FETCH_DEVICE_REJECTED';
export const FILTER_DEVICES_FULFILLED = 'FILTER_DEVICES_FULFILLED';
export const SEARCH_DEVICES_FULFILLED = 'SEARCH_DEVICES_FULFILLED';
export const SORT_DEVICES_FULFILLED = 'SORT_DEVICES_FULFILLED';
export const SORT_DEVICES_PENDING = 'SORT_DEVICES_PENDING';
export const CALCULATED_STATISTICS_FULFILLED = 'CALCULATED_STATISTICS_FULFILLED';
export const UPDATE_DEVICE_FULFILLED = 'UPDATE_DEVICE_FULFILLED';
export const UPDATE_DEVICE_PENDING = 'UPDATE_DEVICE_PENDING';
export const UPDATE_DEVICE_FAILED = 'UPDATE_DEVICE_FAILED';
export const ADD_DEVICE_FULFILLED = 'ADD_DEVICE_FULFILLED';
export const ADD_DEVICE_REJECTED = 'ADD_DEVICE_REJECTED';
export const ADD_DEVICE_PENDING = 'ADD_DEVICE_PENDING';



// ACTION GENERATORS

function generateEvents(device) {
    var events = [];

    if (device.hasOwnProperty('DeviceDetails')) {
        if (device['DeviceDetails'].hasOwnProperty('latest') && device['DeviceDetails'].hasOwnProperty('counts')) {
            let latestEvents = device['DeviceDetails']['latest'];
            let latestEventCounts = device['DeviceDetails']['counts'];

            let latestEventKeys = Object.keys(latestEvents);
            
            latestEventKeys.forEach((key) => {
                let countKey = key.replace("Latest_", "");

                let count = latestEventCounts[countKey];
                let latestEvent = latestEvents[key];
                let event = {name: countKey, count: count, latest: latestEvent};
                events.push(event);
            })

            events.sort((event1, event2) => {
                let event1Date = moment(event1.latest);
                let event2Date = moment(event2.latest);
                return moment(event1Date).isAfter(event2Date);
            })

            return events;
        }
    }

    return [];
}

function parsePharmacies(data) {
    let keys = Object.keys(data);
    var pharmaciesForDeviceUuid = {};
    
    keys.forEach(key => {
        var pharmacy = data[key];
        pharmacy['id'] = key;

        // Return only pharmacies with a valid deviceUuid.
        let devicesAttachedToPharmacy = pharmacy['deviceUuids'];

        if(devicesAttachedToPharmacy !== undefined) {
            // Filter out any historical devices...
            let deviceUuids = Object.keys(devicesAttachedToPharmacy).filter((deviceKey) => {
                let pharmacyDevice = devicesAttachedToPharmacy[deviceKey];
                if (pharmacyDevice.hasOwnProperty("dateRemoved")) {
                    if (moment(pharmacyDevice["dateRemoved"], "HH:mm ddd DD-MM-YYYY").isBefore(moment())) {
                        return false;
                    }
                }

                return true
            });

            // Attach each device UUID to this pharmacy. 
            deviceUuids.forEach(deviceUuid => {
                pharmaciesForDeviceUuid[deviceUuid] = pharmacy
            });
        }
    })
    
    return pharmaciesForDeviceUuid;
}


function parseDevices(devices, pharamaciesForDeviceUuid) {
    let unsortedDevicesKeys = Object.keys(devices);
    var unsortedDevices = [];

    unsortedDevicesKeys.forEach(deviceKey => {
        let device = devices[deviceKey];
        device['id'] = deviceKey;

        let deviceUuid = device['LatestSetupPharmacyId'];
        let pharmacyForDevice = pharamaciesForDeviceUuid[deviceUuid];
        device['deviceName'] = deviceUuid;

        if (pharmacyForDevice != undefined) {
            device.unassigned = false; 
            
            device['pharmacy'] = pharmacyForDevice;
            device['latestEvents'] = generateEvents(device);
            device['isTest'] = pharmacyForDevice['isTest'];
            unsortedDevices.push(device);
        } else {
            device.unassigned = true;
            device['latestEvents'] = [];
            unsortedDevices.push(device);
        }
    })

    return unsortedDevices;
}


const fetchDevicesAction = () => (dispatch) => {
    dispatch({
        type: FETCH_DEVICES_PENDING,
    });

    devicesRef.once('value').then(deviceSnapshot => {
        var unsortedDevices = deviceSnapshot.val();

        pharmaciesRef.once("value").then((pharmacySnapshot) => {
           let pharmacies = pharmacySnapshot.val();
           
            let pharamaciesForDeviceUuid = parsePharmacies(pharmacies);
            let devices = parseDevices(unsortedDevices, pharamaciesForDeviceUuid);

            dispatch({
                type: FETCH_DEVICES_FULFILLED,
                payload: devices
            });
            
        }).catch(error => {
            dispatch({
                type: FETCH_DEVICES_REJECTED,
            });
        })
    }).catch(error => {
        dispatch({
            type: FETCH_DEVICES_REJECTED,
        });
    })
};


const addDeviceAction = (deviceId, pharmacyId) => (dispatch) => {
    let dateAdded = moment().format('HH:mm ddd DD-MM-YYYY');
    let newDevice = { 'LatestSetupPharmacyId' : deviceId, 'TimeSet' : dateAdded };

    dispatch({
        type: ADD_DEVICE_PENDING,
    });

    deviceRef.equalTo(deviceId).once('value').then((snapshot) => {
        let value = snapshot.val();

        if (value === null || value === undefined) {
            // If the device doesn't already exist, then add it to the database. 
            devicesRef.push(newDevice, (error) => {
                if(error) {
                    // The write failed...
                    console.log(error);
                    dispatch({
                        type: ADD_DEVICE_REJECTED,
                    });
                } else {
                    addDeviceToPharmacy(deviceId, pharmacyId, dateAdded, newDevice, dispatch);
                }
            });
        } else {
            // If the device already exists, just add it to the pharmacy.
            addDeviceToPharmacy(deviceId, pharmacyId, dateAdded, newDevice, dispatch);
        }

    }).catch(error => {
        console.log(error);
        dispatch({
            type: ADD_DEVICE_REJECTED,
        });
    })

    
};


function addDeviceToPharmacy(deviceId, pharmacyId, dateAdded, newDevice, dispatch) {
    // If we are attaching it to a specific pharmacy, add to the pharmacies device UUIDs array.
    if(pharmacyId !== undefined) {
        let nodePath = 'Pharmacies/' + pharmacyId + "/deviceUuids/" + deviceId;

        databaseRef.child(nodePath).set({
            'dateAdded' : dateAdded,
            'uuid' : deviceId,
        }, (error) => {
            if (error) {
                // The write failed...
                dispatch({
                    type: ADD_DEVICE_REJECTED,
                });
            } else {
                // Data updated successfully!
                dispatch({
                    type: ADD_DEVICE_FULFILLED,
                    payload: newDevice
                });
            }
        });
    } else {
        dispatch({
            type: ADD_DEVICE_FULFILLED,
            payload: newDevice
        });
    }
}


const filterDevicesAction = (filterType) => (dispatch) => {
    dispatch({
        type: FILTER_DEVICES_FULFILLED,
        payload: filterType
    });
};

const sortDevicesAction = (sortType, directionType) => (dispatch) => {
    let payload = {'sortType': sortType, 'directionType': directionType};

    dispatch({
        type: SORT_DEVICES_PENDING,
    });

    dispatch({
        type: SORT_DEVICES_FULFILLED,
        payload: payload
    });
};

const updateDeviceAction = (entityUpdate, pharmacy) => (dispatch) => {
    dispatch({
        type: UPDATE_DEVICE_PENDING,
    });
    
    let deviceId = pharmacy.id;
    let nodePath = 'Pharmacies/' + deviceId;

    databaseRef.child(nodePath).update(entityUpdate, (error) => {
        if (error) {
            // The write failed...
            dispatch({
                type: UPDATE_DEVICE_FAILED,
            });
        } else {
            // Data updated successfully!
            dispatch({
                type: UPDATE_DEVICE_FULFILLED,
                payload: entityUpdate
            });
        }
    });
};

const deleteDeviceAction = (deviceId) => (dispatch) => {
    dispatch({
        type: DELETE_DEVICE_PENDING,
    });

    let nodePath = 'Pharmacies/' + deviceId;

    databaseRef.child(nodePath).update(entityUpdate, (error) => {
        if (error) {
            // The write failed...
            dispatch({
                type: UPDATE_DEVICE_FAILED,
            });
        } else {
            // Data updated successfully!
            dispatch({
                type: UPDATE_DEVICE_FULFILLED,
                payload: entityUpdate
            });
        }
    });
};

const searchDevicesAction = (searchText) => (dispatch) => {
    dispatch({
        type: SEARCH_DEVICES_FULFILLED,
        payload: searchText
    });
};

const fetchDeviceAction = (deviceUuid) => (dispatch) => {
    dispatch({
        type: FETCH_DEVICE_PENDING,
    });

    let newDevice = {};

    deviceRef.equalTo(deviceUuid).once('value', deviceSnapshot => {
        let device = deviceSnapshot.val();

        databaseRef.child("Pharmacies").orderByChild('deviceUuids/' + deviceUuid + '/uuid').equalTo(deviceUuid).once("value", (pharmacySnapshot) => {
           let attachedToPharmacies = pharmacySnapshot.val();

           console.log("attachedToPharmacies IS...", pharmacySnapshot.val());

           if (device != undefined) {
                let deviceKey = Object.keys(device);
                let deviceInfo = device[deviceKey];

                newDevice = deviceInfo;
                newDevice['id'] = deviceKey[0];

                if (attachedToPharmacies != undefined) {
                    /* 
                        A device could be attached to multiple pharmacies.
                        Need to check if it is attached to one, and if one of its attachements are 
                        still active. Otherwise it is presumed to be a historical device across all pharmacies.
                    */
                   let activePharmacyKey = Object.keys(attachedToPharmacies).filter((pharmacyKey) => {
                       let pharmacy = attachedToPharmacies[pharmacyKey]

                       if (pharmacy.hasOwnProperty('deviceUuids')) {
                           let attachedDevices = pharmacy.deviceUuids
                           if (attachedDevices[deviceUuid].hasOwnProperty('dateRemoved')) {
                               return false;
                           }
                           return true;
                       }
                   })

                    let pharmacyKey = activePharmacyKey[0]

                    if (pharmacyKey !== undefined) {
                        let pharmacyInfo = attachedToPharmacies[pharmacyKey];

                        pharmacyInfo['id'] = pharmacyKey;
                        newDevice['pharmacy'] = pharmacyInfo
    
                        // Generate the latest events for the device.
                        newDevice['latestEvents'] = generateEvents(newDevice);
                    }
                }
           }
           
            dispatch({
                type: FETCH_DEVICE_FULFILLED,
                payload: newDevice
            });
        });
    });
};

// Export Actions
export {
        filterDevicesAction as filterDevices, 
        searchDevicesAction as searchDevices, 
        sortDevicesAction as sortDevices, 
        fetchDevicesAction as fetchDevices,
        fetchDeviceAction as fetchDevice,
        updateDeviceAction as updateDevice,
        addDeviceAction as addDevice,
    };